export default __webpack_public_path__ + "static/media/Facebook icon.2fd40c10.svg";